// src/utils/withApiSafety.ts
import type { AxiosResponse } from 'axios'
import type { ApiResponse } from '@farmfree/common/types/apiResponse'
export async function withApiSafety<T>(
  request: () => Promise<AxiosResponse<ApiResponse<T>>>
): Promise<ApiResponse<T>> {
  try {
    const res = await request()
    return res.data
  } catch (error: any) {
    // 디버깅용 상세 로그
    if (error.response) {
      console.error('❌ API 에러 응답:', {
        status: error.response.status,
        data: error.response.data,
        url: error.config?.url,
        method: error.config?.method,
      })
    } else {
      console.error('❌ API 요청 에러:', error.message)
    }

    // 서버에서 반환한 에러 메시지 우선 사용
    const errorMessage =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error?.message ||
      '요청 중 오류가 발생했습니다.'

    return {
      isSuccess: false,
      message: errorMessage,
      error: errorMessage,
    }
  }
}
